var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NoteList',{attrs:{"delete-permission":'delete_customer',"change-permission":'change_customer',"object-uuid":_vm.customer.uuid,"plural-object-name":"customers","object-name":"customer"}})}
var staticRenderFns = []

export { render, staticRenderFns }